import axios from 'axios'
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react'
import useSWR from "swr"

const ReportPageContext = createContext()

export const ReportPageProvider = ({ uuid, children }) => {
    const { data: templates } = useSWR(`/reports/getTemplates?uuid=${uuid}`)
    const { data: bqTickers } = useSWR(`/api/financialMetricsTickers`)
    const [ isLoading, setisLoading ] = useState(false)
    const [ selectedTickers, setSelectedTickers ] = useState()
    const [ selectedReports, setSelectedReports ] = useState("")
    const [ selectedTemplate, setSelectedTemplate ] = useState(null)
    const [ tab, setTab ] = useState(false)

    useEffect(() =>{ selectedTickers && !selectedTickers.map(({value}) => value).includes(tab?.value) && setTab(selectedTickers[0] ?? false);return () => {} },[tab, selectedTickers])

    useEffect(() => {
        selectedTickers && selectedReports && uuid 
            // && fetch('/reports/saveReportsParams', {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify({
            //         uuid, tickers: selectedTickers.map(({value})=> value), report: selectedReports
            //     })
            // })
            && axios({
                method: 'POST',
                url:'/reports/saveReportsParams',
                data:{uuid, tickers: selectedTickers.map(({value})=> value), report: selectedReports}
            })
        return () => {}
    },[selectedTickers, selectedReports, uuid])

    useEffect(() => {
        setisLoading(true)
        uuid && axios.get(`/reports/getReportsParams?uuid=${uuid}`)
        .then(res => res.data)
        .then(res => {
            if(res){
                setSelectedReports(res.report_value)
                setSelectedTickers(res.tickers)
            }
            setisLoading(false)
        })
        return () => {}
    },[uuid])

    useEffect(() => {
        if(uuid && !selectedReports && templates && !isLoading) {
            const selected = templates.find(template => template.default)
            setSelectedReports(selected.value)
        }
        return () => {}
    },[selectedReports, templates, uuid, isLoading])

    useEffect(() => {
        const selected = selectedReports ? templates?.find(template => template.value === selectedReports) : {}
        setSelectedTemplate(selected)
        return () => {}
    },[selectedReports, templates])

    const handleUpdateTickers = (updated) => setSelectedTickers(updated)

    const handleUpdateReportTemplate = (e) => {
        setSelectedTemplate(null)
        setSelectedReports(e.target.value)
    }

    const handleChangeTab = useCallback((newValue) => setTab(newValue), [])
    
    return (
        <ReportPageContext.Provider value={{
            selectedTickers,
            selectedReports,
            handleUpdateTickers,
            handleUpdateReportTemplate,
            templates,
            selectedTemplate: selectedTemplate?.template,
            peerAnalysisTemplate: selectedTemplate?.peer_analysis,
            uuid,
            handleChangeTab,
            tab,
            bqTickers
        }}>
            { children}
        </ReportPageContext.Provider>
    )

}

export function useReportPageContext() {
    return useContext(ReportPageContext)
}